<template>
  <page :basic="isBasic">
    <sidebar v-if="!isBasic" slot="sidebar"/>
    <span slot="header">Modules</span>
    <template slot="breadcrumbs">
      <template v-if="role === 'owner' || role === 'master' || role ==='admin'">
        <div>
          <router-link :to="{name: 'admin-modules'}">
            <i class="fas fa-exchange-alt"></i> Switch to Admin View
          </router-link>
        </div>
      </template>
      <template v-if="role !== 'owner'">
        <div>
          <router-link :to="{name: 'starred-topics'}">
            <i class="fas fa-star"></i> Your Starred Topics
          </router-link>
        </div>
      </template>
    </template>
    <modules-table :view="view"/>
  </page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import modulesTable from './table'
import page from '../../../templates/page'
import sidebar from '../../../sidebar'

export default {
  components: {
    modulesTable,
    page,
    sidebar
  },
  computed: {
    ...mapState('modules', {
      view: '_clientView'
    }),
    ...mapGetters('client', {
      role: 'getCurrentRole'
    }),
    ...mapState('tenants', {
      organization: 'current'
    }),
    isBasic () {
      if (this.organization && this.organization.enable_bioreq && this.organization.enable_bioreq === 1)
      {
        return false
      }

      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/modules/index.vue